import { render, staticRenderFns } from "./DeliveryMethodSummary.vue?vue&type=template&id=666ba34a"
import script from "./DeliveryMethodSummary.vue?vue&type=script&lang=ts"
export * from "./DeliveryMethodSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports